import type { CtaErrorDetail } from '@chat-emp/shared';

/**
 * The host's answer to an `event`-mode CTA click, delivered to whichever button
 * is still spinning for it.
 *
 * Module state rather than React state for the same reason as `gamification.ts`:
 * the writer is the bridge switch in a view, the reader is a hook mounted per
 * message-with-a-row, and threading a prop between them would touch every
 * component in the thread to serve a message that arrives rarely and concerns
 * exactly one of them.
 *
 * Failure only. A host that RESOLVED the action tells the backend, which seals
 * the row and broadcasts `message.updated`; there is no success path through
 * here because the terminal state is not the host's to write.
 */
type Listener = (detail: CtaErrorDetail) => void;

const listeners = new Set<Listener>();

export function onCtaError(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function reportCtaError(detail: CtaErrorDetail): void {
  for (const listener of listeners) listener(detail);
}
